// Converte o áudio gravado para WAV.
//
// O MediaRecorder grava em WebM/MP4, que são formatos de fluxo: o cabeçalho
// sai sem a duração, porque no momento em que ele é escrito ainda não se sabe
// quanto tempo a gravação vai ter. A biblioteca do WhatsApp lê essa duração
// antes de enviar e, sem ela, estoura "End-Of-Stream" e a mensagem não sai.
//
// O WAV declara tamanho e duração no cabeçalho, então o envio funciona. Fica
// maior — cerca de 350 kB por minuto neste formato — mas mensagem de voz de
// atendimento dura segundos, e o WhatsApp recodifica para Opus no caminho.

// Mono e 16 kHz: é voz, não música. Estéreo dobraria o tamanho sem ganho
// nenhum, e 16 kHz é a taxa que a telefonia usa há décadas.
const CANAIS = 1;
const TAXA = 16000;

const reamostrar = async (buffer) => {
  const destino = new OfflineAudioContext(
    CANAIS,
    Math.ceil((buffer.duration * TAXA) || 1),
    TAXA
  );

  const fonte = destino.createBufferSource();
  fonte.buffer = buffer;
  fonte.connect(destino.destination);
  fonte.start();

  return destino.startRendering();
};

const montarWav = (amostras) => {
  // 44 bytes de cabeçalho RIFF + 2 bytes por amostra (16 bits).
  const buffer = new ArrayBuffer(44 + amostras.length * 2);
  const view = new DataView(buffer);

  const escreverTexto = (posicao, texto) => {
    for (let i = 0; i < texto.length; i += 1) {
      view.setUint8(posicao + i, texto.charCodeAt(i));
    }
  };

  const bytesDeDados = amostras.length * 2;

  escreverTexto(0, "RIFF");
  view.setUint32(4, 36 + bytesDeDados, true);
  escreverTexto(8, "WAVE");
  escreverTexto(12, "fmt ");
  view.setUint32(16, 16, true); // tamanho do bloco fmt
  view.setUint16(20, 1, true); // PCM
  view.setUint16(22, CANAIS, true);
  view.setUint32(24, TAXA, true);
  view.setUint32(28, TAXA * CANAIS * 2, true); // bytes por segundo
  view.setUint16(32, CANAIS * 2, true); // alinhamento do bloco
  view.setUint16(34, 16, true); // bits por amostra
  escreverTexto(36, "data");
  view.setUint32(40, bytesDeDados, true);

  // Float (-1..1) para inteiro de 16 bits com sinal.
  let posicao = 44;
  for (let i = 0; i < amostras.length; i += 1) {
    const limitado = Math.max(-1, Math.min(1, amostras[i]));
    view.setInt16(
      posicao,
      limitado < 0 ? limitado * 0x8000 : limitado * 0x7fff,
      true
    );
    posicao += 2;
  }

  return new Blob([buffer], { type: "audio/wav" });
};

export const paraWav = async (blob) => {
  const dados = await blob.arrayBuffer();
  const contexto = new (window.AudioContext || window.webkitAudioContext)();

  try {
    const decodificado = await contexto.decodeAudioData(dados);
    const reduzido = await reamostrar(decodificado);

    return montarWav(reduzido.getChannelData(0));
  } finally {
    contexto.close();
  }
};
